import { ApiDOMError } from '@swagger-api/apidom-error';

/**
 * @public
 */
class JsonSchema$anchorError extends ApiDOMError {}
export default JsonSchema$anchorError;